import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, HostListener, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CategoriasWebMenu, EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { Router } from '@angular/router';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'category-scroll-filter',
  templateUrl: './category-scroll-filter.component.html',
  styleUrls: ['./category-scroll-filter.component.scss']
})
export class CategoryScrollFilterComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  
  categorias: CategoriasWebMenu[] = [];
  categoriaSeleccionada: number | null = null;
  showLeftArrow: boolean = false;
  showRightArrow: boolean = false;

  constructor(
    private genServ: EcommerceGenericoService,
    private serv: MarianomGeneral,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.categorias = this.genServ.getCategoriasWeb();
    setTimeout(() => this.checkArrows(), 500);

    // Suscribirse a cambios en la búsqueda para sincronizar el estado visual
    this.genServ.getAvisoArticulosSucursalCargados().subscribe(() => {
        this.categorias = this.genServ.getCategoriasWeb();
        setTimeout(() => this.checkArrows(), 500);
    });
  }

  private resizeObserver: ResizeObserver;
  private mutationObserver: MutationObserver;

  ngAfterViewInit(): void {
    setTimeout(() => this.checkArrows(), 500);

    if (this.scrollContainer) {
      this.resizeObserver = new ResizeObserver(() => {
        this.checkArrows();
      });
      this.resizeObserver.observe(this.scrollContainer.nativeElement);

      this.mutationObserver = new MutationObserver(() => {
        this.checkArrows();
      });
      this.mutationObserver.observe(this.scrollContainer.nativeElement, { childList: true, subtree: true });
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  selectCategory(cat: CategoriasWebMenu) {
    if (this.categoriaSeleccionada === cat.categoria) {
        this.categoriaSeleccionada = null;
        this.genServ.iniciarbusqueda('');
    } else {
        this.categoriaSeleccionada = cat.categoria;
        this.genServ.busquedaCategoria(cat, cat);
        
        if (!this.router.url.includes('/busqueda')) {
            this.router.navigate(['/busqueda']);
        }
    }
  }

  scroll(direction: 'left' | 'right') {
    const container = this.scrollContainer.nativeElement;
    const scrollAmount = 300;
    if (direction === 'left') {
      container.scrollLeft -= scrollAmount;
    } else {
      container.scrollLeft += scrollAmount;
    }
    setTimeout(() => this.checkArrows(), 300);
  }

  onScroll() {
    this.checkArrows();
  }

  checkArrows() {
    if (!this.scrollContainer) return;
    const element = this.scrollContainer.nativeElement;
    // Agregamos un pequeño margen (1px) de tolerancia para evitar parpadeos
    this.showLeftArrow = element.scrollLeft > 1;
    this.showRightArrow = Math.ceil(element.scrollLeft + element.clientWidth) < element.scrollWidth - 1;
    this.cdr.detectChanges();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkArrows();
  }
}
